import { combineReducers } from "redux";
import { PURGE, REHYDRATE } from 'redux-persist';
import LandingPageReducer from "../src/shared/components/ITPLanding/reducers/index";
import MVALandingPageReducer from "../src/shared/components/LandingPage/reducers/index";
import ChargesModalReducer from "../src/shared/components/LandingPage/reducers/chargesModal";
import UsageModalReducer from "../src/shared/components/LandingPage/reducers/usageModal";
import tabStateReducer from "../src/shared/components/ITPLanding/reducers/tabchange";
import DestinationReducer from "../src/ITP/Destination/reducers";
import { travelDateReducer } from "./ITP/TravelDates/reducers/reducer";
import { deviceSelectionReducer, deviceCompatibleReducer /*, deviceCompatibleFlagReducer */} from "./ITP/DeviceSelection/reducers/reducer";
import { PlanSelectionReducer } from "../src/ITP/PlanSelection/reducers";
import { countyListReducer } from "../src/shared/components/CountryListModal/reducer";
import { EffectiveDateReducer } from "../src/ITP/EffectiveDate/reducers";
import { reviewPageReducer } from "../src/ITP/ReviewPage/reducers";
import { confirmationPageReducer } from "../src/ITP/Confirmation/reducers";
import {RemarksReducer} from "../src/ITP/Remarks/reducers/index"
import {ILDRemarksReducer} from "../src/ILD/ILDRemarks/reducers/index"

import ILDDestinationReducer from "../src/ILD/Destination/reducers";
import { ILDEffectiveDateReducer } from "../src/ILD/EffectiveDate/reducers";
import ILDDeviceSelectionReducer from "../src/ILD/ILDDeviceSelection/reducers";
import ILDFeatureComparisonReducer from "../src/ILD/FeatureComparison/reducers";
import { ILDReviewPageReducer } from "../src/ILD/ReviewPage/reducers";
import { ILDConfirmationPageReducer } from "../src/ILD/Confirmation/reducers";
import ILDLandingPageReducer from "../src/ILD/LandingPage/reducers/index";
import ILDtabStateReducer from "../src/ILD/LandingPage/reducers/tabchange";
import removePageReducer  from "../src/RemovePlanPage/reducers/reducer";
import RpEffectiveDateReducer from "../src/RemovePlanPage/reducers/rpEffectiveDate";
import { RpReviewPlanReducer } from "../src/RemovePlanPage/reducers/rpReviewPlan";
import { RpConfirmationPageReducer } from "./RemovePlanPage/reducers/rpConfirm";

import { PendingOrderReducer } from "./PendingOrder/reducers/index";
import { InternationalRepToolsReducer } from "./ITP/RepTool/reducers/index";
import {InternationalRepToolsReducer_ILD}from"./ILD/ILDRepTool/reducers/index"
import AlertSettingsReducer from "../src/shared/components/LandingPage/reducers/alertSettings";

const initialState = {};

export const prodReducer = (state = initialState, actions) => {
  switch (actions.type) {
    default:
      return state;
  }
};

// export const removePageReducer = (state = initialState, actions) => {
//   switch (actions.type) {
//     default:
//       return state;
//   }
// };

const appReducer = combineReducers({
  prodApp: prodReducer,
  
  
  
  //deviceCompatibleFlagReducer: deviceCompatibleFlagReducer,
  ITP_LandingPage: LandingPageReducer,
  ITP_tabState: tabStateReducer,
  ITP_Destination: DestinationReducer,
  ITP_TravelDate: travelDateReducer,
  ITP_DeviceSelectionData: deviceSelectionReducer,
  ITP_deviceCompatibleReducer: deviceCompatibleReducer,
  ITP_PlanSelection: PlanSelectionReducer,
  ITP_EffectiveDate: EffectiveDateReducer,
  ITP_ReviewPage: reviewPageReducer,
  ITP_ConfirmationPage: confirmationPageReducer,
  CountryListData: countyListReducer,
  
  ILD_LandingPage: ILDLandingPageReducer,
  ILD_tabState: ILDtabStateReducer,
  ILD_Destination: ILDDestinationReducer,
  ILD_EffectiveDate: ILDEffectiveDateReducer,
  ILD_DeviceSelectionReducer: ILDDeviceSelectionReducer,
  ILD_FeatureComparison: ILDFeatureComparisonReducer,
  ILD_ReviewPage: ILDReviewPageReducer,
  ILD_ConfirmationPage: ILDConfirmationPageReducer,
  
  RemovePlanLand: removePageReducer,
  RpEffectiveDate: RpEffectiveDateReducer,
  RpReviewPlan: RpReviewPlanReducer,
  RpConfirm: RpConfirmationPageReducer,

  PendingOrder:PendingOrderReducer,
  InternationalRepTools:InternationalRepToolsReducer,
  InternationalRepTools_ILD:InternationalRepToolsReducer_ILD,
  RemarksReducer:RemarksReducer,
  ILDRemarksReducer:ILDRemarksReducer,
  MVALandingPageReducer : MVALandingPageReducer,
  UsageModalReducer:UsageModalReducer,
  ChargesModalReducer:ChargesModalReducer,
  AlertSettingsReducer: AlertSettingsReducer
});

const rootReducer = (state = initialState, action) => {
  //if (action.type === SIGNOUT_REQUEST) {
  if (action.type === REHYDRATE) {
  }
  else if (action.type === PURGE) {
    sessionStorage.removeItem('persist:intlroot');
    //sessionStorage.clear();    
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
